import React from "react";

const NewProjectContext = React.createContext({
  designStyles: {
    works: [],
    spaces: [],
    styles: [],
  },
  step: 1,
  goForward: () => {},
  goBack: () => {},
  details: {},
  setDetails: () => {},
  onSuccess: (id) => {},
});

export default NewProjectContext;
